<router-outlet></router-outlet>

@if (soundBlocked) {
  <div
    class="sound-unlock-banner"
    role="alert"
    (click)="notificationAlertService.unlockSound()"
  >
    <span class="sound-unlock-banner__icon">🔔</span>
    <span class="sound-unlock-banner__text">
      Notification sound is muted by the browser. Tap anywhere to enable alert sound.
    </span>
  </div>
}
